module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page video-page create-page mx-5"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "page-left"
  }, [_c('div', {
    staticClass: "tab-container"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("Broadcast")]), _vm._v(" "), _c('ul', {
    staticClass: "pr-3"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      class: {
        active: tab.id === _vm.active_tab
      }
    }, [_c('label', {
      on: {
        "click": function($event) {
          _vm.onTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }))])]), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit()
      }
    }
  }, [_c('h3', {
    staticClass: "mt-3 mb-4"
  }, [_vm._v("Broadcast Details")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-5",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Title of Event")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stream.name),
      expression: "stream.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.stream.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.stream, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pay Per View?")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.view_prices,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.view_price),
      callback: function($$v) {
        _vm.$set(_vm.stream, "view_price", $$v)
      },
      expression: "stream.view_price"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Event Capacity")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "pt-0",
    attrs: {
      "items": _vm.viewers_limits,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.stream.viewers_limit),
      callback: function($$v) {
        _vm.$set(_vm.stream, "viewers_limit", $$v)
      },
      expression: "stream.viewers_limit"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Genre")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.stream.genre.name))])]), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-5"
  }, [_c('v-btn', {
    staticClass: "px-5",
    attrs: {
      "round": "",
      "dark": "",
      "color": "blue",
      "type": "submit"
    }
  }, [_vm._v("Update Channel")])], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm7": "",
      "pl-5": ""
    }
  }, [_c('div', [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Thumbnail")]), _vm._v(" "), _c('div', {
    staticClass: "video-thumbnail-wrapper"
  }, [(_vm.stream_cover_url) ? _c('div', {
    staticClass: "video-thumbnail",
    style: ({
      'background-image': 'url(' + _vm.stream_cover_url + ')',
    })
  }) : _vm._e()])]), _vm._v(" "), (_vm.stream.account_ids.length > 0) ? _c('div', {
    staticClass: "form-group mt-2"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Feature profiles")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.users,
      "multiple": "",
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Type name to search",
      "chips": "",
      "autocomplete": "",
      "readonly": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          key: JSON.stringify(data.item),
          attrs: {
            "selected": data.selected
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_c('v-avatar', [_c('img', {
          attrs: {
            "src": data.item.avatar.url
          }
        })]), _vm._v("\n                    " + _vm._s(data.item.username) + "\n                  ")], 1)]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-avatar', [_c('img', {
          attrs: {
            "src": data.item.avatar.url
          }
        })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.username)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.stream.account_ids),
      callback: function($$v) {
        _vm.$set(_vm.stream, "account_ids", $$v)
      },
      expression: "stream.account_ids"
    }
  })], 1) : _vm._e()])], 1)], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa2c789","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/video/edit.vue
// module id = 1664
// module chunks = 180